import { ROUTES } from '@/constants/routes';
import { BusinessesListItem } from '@/types/businesses';
import { formatCurrency } from '@/utils/currency';
import { useNavigate } from 'react-router-dom';
import { SVListItemCard } from '../core';

type BusinessesListProps = {
  businesses: BusinessesListItem[];
};

export default function BusinessesList({ businesses }: BusinessesListProps) {
  const navigate = useNavigate();

  return (
    <>
      {businesses.map(business => {
        const { uuid, status, aggregateInfo, company, legalBusinessName } =
          business;

        return (
          <SVListItemCard
            onClick={() => navigate(`${ROUTES.BUSINESSES}/${uuid}`)}
            key={uuid}
            header={legalBusinessName}
            status={status}
            statusType="standard"
            manageMenuItems={[
              {
                label: 'Edit',
                onClick: () =>
                  navigate(`${ROUTES.BUSINESSES_EDIT_PARAMS}/${uuid}`),
              },
              {
                label: 'Accounts',
                onClick: () =>
                  navigate(`${ROUTES.BANK_ACCOUNTS}?business_id=${uuid}`),
              },
              {
                label: 'Applications',
                onClick: () =>
                  navigate(
                    `${ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED}?business_id=${uuid}`,
                  ),
              },
              {
                label: 'Members',
                onClick: () =>
                  navigate(`${ROUTES.CUSTOMERS}?business_id=${uuid}`),
              },
            ]}
            additionalInfo={[
              {
                label: 'Members',
                text: aggregateInfo.totalMembers,
              },
              {
                label: 'Active Bank Accounts',
                text: aggregateInfo.totalActiveBankAccounts,
              },
              {
                label: 'Available Balance',
                text: formatCurrency({
                  amount: aggregateInfo.totalAvailableBalance.value,
                }),
              },
              {
                label: 'Company',
                text: company.name,
              },
            ]}
          />
        );
      })}
    </>
  );
}
